export default __webpack_public_path__ + "ccfdd78d095fe3607726da612d40597a.ttf";